import { getAccreditationDocumentsAction } from '../redux/Reducers/accreditationDocumentsReducer';
import { BASE_URL } from './BASE_URL';

export const getAccreditationDocuments = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + 'information/accreditation/');
    const data = await response.json();
    if (response.status === 200) {
      dispatch(getAccreditationDocumentsAction(data));
    }
  };
};
